export default [
  {
    path: '/projects',
    name: 'projects',
    props: true,
    component: () => import(/* webpackChunkName: "projects" */ './Projects.vue'),
    redirect: { name: 'projects-list' },
    children: [
      {
        path: 'list',
        name: 'projects-list',
        component: () => import(/* webpackChunkName: "projects" */ './list/List.vue'),
      },
      {
        path: ':projectId',
        name: 'projects-project',
        props: true,
        component: () => import(/* webpackChunkName: "project" */ './project/Project.vue'),
        children: [
          {
            path: 'people',
            name: 'projects-project-people',
            props: true,
            component: () =>
              import(/* webpackChunkName: "project-people" */ './project/people/People.vue'),
            children: [
              {
                path: 'people',
                name: 'projects-project-people-people',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "project-people" */ './project/people/people/People.vue'
                  ),
              },
              {
                path: 'teams',
                name: 'projects-project-people-teams',
                props: true,
              },
            ],
          },
          {
            path: 'notebooks',
            name: 'projects-project-notebooks',
            component: () =>
              import(
                /* webpackChunkName: "project-notebooks" */ './project/notebooks/Notebooks.vue'
              ),
            redirect: { name: 'projects-project-notebooks-list' },
            children: [
              {
                path: 'list',
                name: 'projects-project-notebooks-list',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "project-notebooks-list" */ './project/notebooks/NotebookList.vue'
                  ),
              },
              {
                path: 'create',
                name: 'projects-project-notebooks-create',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "project-notebooks" */ './project/notebooks/NotebookCreate.vue'
                  ),
              },
              {
                path: ':notebookId/edit',
                name: 'projects-project-notebooks-edit',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "project-notebooks" */ './project/notebooks/NotebookEdit.vue'
                  ),
              },
              {
                path: ':notebookId',
                name: 'projects-project-notebooks-details',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "project-notebooks" */ './project/notebooks/NotebookDetails.vue'
                  ),
              },
            ],
          },
          {
            path: 'forms',
            props: true,
            component: () =>
              import(/* webpackChunkName: "project-forms" */ './project/forms/Root.vue'),
            children: [
              {
                path: '',
                name: 'projects-forms-forms',
                props: true,
                component: () =>
                  import(/* webpackChunkName: "project-forms" */ './project/forms/Forms.vue'),
              },
              {
                path: ':formId',
                name: 'projects-forms-form',
                props: true,
                component: () =>
                  import(/* webpackChunkName: "project-forms" */ './project/forms/Form.vue'),
              },
            ],
          },
        ],
      },
    ],
  },
];
